const SESSION_STORAGE_KEY = "oa.ainaMentorIconNudge.shown.v1";

export function readAinaMentorIconNudgeShownThisSession(): boolean {
  if (typeof window === "undefined") return true;
  return sessionStorage.getItem(SESSION_STORAGE_KEY) === "1";
}

export function writeAinaMentorIconNudgeShownThisSession(): void {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(SESSION_STORAGE_KEY, "1");
}

/** Call on logout so the nudge can appear again after the next login. */
export function clearAinaMentorIconNudgeSession(): void {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(SESSION_STORAGE_KEY);
}
